module.exports = __webpack_public_path__ + "static/media/meli.e20ea2cb.svg";